import React from 'react';

/**
 * ModalHeader Component
 * 
 * Modal header with icon, title, subtitle, and close button
 */
const ModalHeader = ({ 
  isUpdate, 
  deliverableName, 
  onClose, 
  isUploading 
}) => {
  return (
    <div className="deliverable-submit-modal__header">
      <div className="deliverable-submit-modal__icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="17 8 12 3 7 8" />
          <line x1="12" y1="3" x2="12" y2="15" />
        </svg>
      </div>
      <div className="deliverable-submit-modal__title-group">
        <h2 className="deliverable-submit-modal__title">
          {isUpdate ? 'Change Your Submission' : 'Submit Deliverable'}
        </h2>
        <span className="deliverable-submit-modal__subtitle">{deliverableName}</span>
        {isUpdate && (
          <p className="deliverable-submit-modal__update-hint">
            You already submitted something for this. Pick a new file or link to replace it.
          </p>
        )}
      </div>
      <button 
        className="deliverable-submit-modal__close" 
        onClick={onClose}
        disabled={isUploading}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  );
};

export default ModalHeader;
